// extracted by mini-css-extract-plugin
export var currencyInput = "_l0-1";
export var currencySymbol = "_l0-0";